




























import { Location } from 'vue-router';
import Vue from 'vue';

export default Vue.extend({
    props: {
        title: {
            type: String,
            default: null,
        },
        url: {
            type: String,
            default: null,
        },
        route: {
            type: String,
            default: null,
        },
    },
    computed: {
        routerTo(): Location {
            return { name: this.route };
        },
    },
});
